import { useEffect } from 'react';
import styles from './Simple.module.css';
import { Button, Card, Logo } from '../components/ui';

export function NotFound() {
  useEffect(() => {
    document.title = 'Page not found — Don Quack';
  }, []);

  return (
    <div className={styles.center}>
      <Card padding="lg" radius="xl" className={styles.card}>
        <Logo size={34} />
        <h1 className={styles.title}>This page flew off</h1>
        <p className={styles.body}>
          The link you followed doesn&rsquo;t lead anywhere. Try the home page.
        </p>
        <div className={styles.actions}>
          <Button to="/">Back to the site</Button>
        </div>
      </Card>
    </div>
  );
}
